import { useState } from "react";
import { toast } from "sonner";
import { ArrowRight, Mail } from "lucide-react";
import { Reveal } from "@/lib/motion";
import { api, formatApiError } from "@/lib/api";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter", { email });
      toast.success(data.message);
      setEmail("");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="py-20 bg-white" data-testid="newsletter-section">
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <Reveal>
          <div className="relative overflow-hidden rounded-[2rem] px-8 py-12 sm:px-14 sm:py-16" style={{ background: "linear-gradient(120deg,#6C2BD9,#2563EB)" }}>
            <div className="absolute -top-16 -right-10 w-72 h-72 rounded-full bg-white/10 blur-2xl" />
            <div className="absolute -bottom-20 -left-10 w-72 h-72 rounded-full bg-[var(--dm-orange)]/20 blur-2xl" />
            <div className="relative grid lg:grid-cols-2 gap-8 items-center">
              <div>
                <span className="inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-1.5 text-white overline mb-4">
                  <Mail size={14} /> Marketing Insights
                </span>
                <h2 className="font-head font-extrabold tracking-tighter text-3xl sm:text-4xl text-white leading-[1.05]">
                  Get growth tips in your inbox
                </h2>
                <p className="mt-3 text-white/80 max-w-md">
                  Join our newsletter for actionable marketing strategies, case studies and trends — no spam, ever.
                </p>
              </div>
              <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3" data-testid="newsletter-band-form">
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  data-testid="newsletter-band-input"
                  className="flex-1 rounded-full bg-white px-5 py-4 text-sm text-slate-900 placeholder:text-slate-400 focus:outline-none"
                />
                <button type="submit" disabled={loading} data-testid="newsletter-band-submit" className="rounded-full bg-[#0F172A] text-white px-7 py-4 font-head font-bold flex items-center justify-center gap-2 transition-transform hover:-translate-y-0.5 disabled:opacity-70">
                  Subscribe <ArrowRight size={17} />
                </button>
              </form>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
